import React, {Component} from 'react';
import {
    Badge,
    Button,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Progress,
    UncontrolledButtonDropdown
} from 'reactstrap';
import HTML from '../../common/HtmlHelpers';
import Utils from '../../common/Utils';
import {AnalyticsEndpoints, MiscEndpoints, TractorRequestEndpoints} from '../../common/ProxyEndpoints';
import './Dashboard.css';
import SessionStateManager from '../../common/SessionStateManager';
import CardTile from "../../components/CardTile/CardTile";
import StatisticsChart from "../../components/StatisticsChart/StatisticsChart";
import AppVariables from "../../common/AppVariables";
import {CreationLineChart, getTimeFrameRange, InfoBar} from './DashboardCommon';
import {
    MaxExpectedFBO,
    MaxExpectedOperators,
    MaxExpectedTractorOwners,
    MaxExpectedTractors,
    MaxPendingRequests
} from './DashboardExpectations';
import {RequestTimeFrame} from "../../common/Constants";
import Spinkit from 'react-spinkit';
import TTLProxy from "../../common/TTLAsyncProxy";
import CommissionInfoDialog from "../../components/CommisionInfoDialog/CommissionInfoDialog";
import DocumentTitle from 'react-document-title';
import {ic_date_range} from 'react-icons-kit/md/ic_date_range';
import {ic_view_day} from 'react-icons-kit/md/ic_view_day';
import {ic_view_week} from 'react-icons-kit/md/ic_view_week';
import Icon from 'react-icons-kit';
import MDSpinner from "react-md-spinner";

/***
 * Chart Colors
 * @type {string}
 */

const brandPrimary =  '#20a8d8';
const brandSuccess =  '#4dbd74';
const brandInfo =     '#63c2de';
const brandDanger =   '#56f837';

const AnalyticsRangeOptions = {
    Yearly: "yearly",
    Monthly : "monthly",
    Weekly: "weekly",
};

function formatAnalyticsRangeOption(range) {

    for(let item in AnalyticsRangeOptions){
        if(AnalyticsRangeOptions.hasOwnProperty(item) && range === AnalyticsRangeOptions[item]){
            return item;
        }
    }

}

function computePercentage(value, expected) {
    return (value / expected) * 100;
}


/**
 * Dashboard - Admin View
 */
class DashboardAdmin extends Component {

    session;

    _isMounted = false;

    constructor(props) {
        super(props);

        //  Session Manager
        const session = new SessionStateManager('admin_dashboard', false );
        this.session = session;

        //
        this.state = {
            dropdownOpen: false,
            isBusy: false,
            faulted: session.getState('faulted',false),
            isLoaded: session.getState('isLoaded',false),
            errorMessage: null,
            analyticState: session.getState('analytics_state',{}),
            tooltipState: session.getState('tooltipState',{}),
            dashboardStats: session.getState('dashboardStats', {

                //  Tractors Frame
                tractors: {

                    //  The total no. of tractors
                    total: 0,

                    //  The total no. of active tractors
                    active: 0,

                    //  The total no. of inactive tractors
                    inactive: 0,

                    //  The total no. of assigned tractors
                    assigned: 0,

                    //  The total no. of unassigned tractors
                    unassigned: 0
                },

                //  Farmers Frame
                farmers: {

                    //  The total no. of farmers
                    total: 0,

                    gender: {

                        //  Male farmers
                        male: 0,

                        //  Female farmers
                        female: 0,

                        //  Unknown gender farmers
                        unassigned: 0
                    },

                    fbo: {

                        //  Total number of farmers who have fbo's
                        assigned: 0,

                        //  Total number of farmers with no fbo's
                        unassigned: 0
                    }
                },

                //  Tractor Requests Frame
                tractorRequests: {

                    //  The total tractor requests
                    total: 0,

                    //  The total number of completed requests
                    complete: 0,

                    //  The total number of assigned requests
                    assigned: 0,

                    //  The total number of pending or unassigned requests
                    unassigned: 0,

                    //  The total number of paid unassigned requests
                    totalPaidUnassigned: 0,

                    //  Total number of cancelled requests
                    cancelled: 0,

                    //  Total acreage completed
                    totalAcreage: 0,

                    //  Total hectarage completed
                    totalHectarage: 0,

                    //  Total acreage assigned requests
                    totalAcreageAssigned: 0,

                    //  Total hectarage assigned requests
                    totalHectarageAssigned: 0,

                    //  Total commission from completed requests
                    totalCommission: 0,

                    //  Total money given to tractor owners from completed requests
                    totalPayouts: 0,

                    //  Total income generated from completed requests
                    totalIncome: 0,

                    //  The raw total income to be generated from assigned but not completed requests.
                    totalPendingIncome: 0,

                    //  The total amount of commission to be generated from assigned but not completed requests
                    totalPendingCommission: 0,

                    //  The total amount of money to be given to tractor owners from assigned but not completed requests
                    totalPendingPayout: 0,
                },

                //  Tractor Operators
                operators: {

                    //  The total no. of tractor operators
                    total: 0,

                    //  The total no. of tractor operators who are currently assigned on a request
                    assigned: 0,

                    //  The total no. of tractor operators who are currently unassigned
                    unassigned: 0,

                    gender: {

                        //  Male operators
                        male: 0,

                        //  Female operators
                        female: 0,

                        //  Unassigned gender operators
                        unassigned: 0
                    }
                },

                //  Tractor Owners
                owners: {

                    //  The total no. of tractor owners
                    total: 0,

                    //  The total no. of individual tractor owners
                    individual: 0,

                    //  The total no. of company based tractor owners
                    company: 0
                },

                //  Farmer Based Organization
                fbo: {

                    //  The total no. of FBO's
                    total: 0
                }
            }),
            dashboardStatsLoaded: session.getState("dashboardStatsLoaded",false),
            requestsStats: session.getState('requestsStats', {
                time_frame:  RequestTimeFrame.Day,
                assigned_requests: [],
                unassigned_requests: [],
                completed_requests: [],
                cancelled_requests: []
            }),

            //  Analytics view info
            analyticsRangeOption: session.getState('analyticsRangeOption', AnalyticsRangeOptions.Monthly),
            isFetchingAnalyticsData: false
        };

        //
        this.proxy = TTLProxy.getInstance();
    }

    persistSession(){

        //
        this.session.putStateFrame({
            faulted: this.state.faulted,
            isLoaded: this.state.isLoaded,
            analyticState: this.state.analyticState,
            tooltipState: this.state.tooltipState,
            dashboardStats: this.state.dashboardStats,
            dashboardStatsLoaded: this.state.dashboardStatsLoaded,
            requestsStats: this.state.requestsStats,
            analyticsRangeOption: this.state.analyticsRangeOption,
        });

        //  persist
        this.session.save();
    }


    componentWillUnmount(){

        //  persist state in session
        this.persistSession();

        //  set not mounted
        this._isMounted = false;

    }

    setStateSafe(state,callback){

        if(this._isMounted){
            this.setState(state,callback);
        }

    }

    async fetchModelStats(){

        this.setStateSafe({ isFetchingAnalyticsData: true });

        try {

            const response = await this.getEntityCreateStats(['farmers', 'operators', 'tractors', 'owners', 'fbo']);
            let payload = response.getPayload();

            let state = this.state.analyticState;
            state.farmerCreateStats = payload.farmers;
            state.fboCreateStats = payload.fbo;
            state.operatorCreateStats = payload.operators;
            state.ownerCreateStats = payload.owners;
            state.tractorCreateStats = payload.tractors;
            this.setState({
                analyticState: state
            });

        }
        finally {
            this.setStateSafe({ isFetchingAnalyticsData: false });
        }

    }


    getEntityCreateStats(entities){

        const { analyticsRangeOption  } = this.state;

        let timeFrame , range;
        switch (analyticsRangeOption) {
            case AnalyticsRangeOptions.Weekly:
                timeFrame = RequestTimeFrame.Week;
                range = { min: 9 , max: 1 };
                break;
            case AnalyticsRangeOptions.Monthly:
                timeFrame = RequestTimeFrame.Month;
                range = { min: 9 , max: 1 };
                break;
            case AnalyticsRangeOptions.Yearly:
                timeFrame = RequestTimeFrame.Year;
                range = { min: 3 , max: 3 };
                break;
        }

        return this.proxy.processRequest( AnalyticsEndpoints.getCreateStats(entities, timeFrame , range , 1) );
    }

    fetchRequestsStats(timeFrame){

        const me = this;
        timeFrame = timeFrame === undefined ? this._reqChart.getTimeFrame() : timeFrame;
        return this.proxy.processRequest(TractorRequestEndpoints.getStats(timeFrame  ,  getTimeFrameRange(timeFrame), 1 ))
            .then((response) => {

                me.setState({
                    requestsStats: response.getPayload()
                });

            });
    }

    queryData() {

        //
        const proxy = this.proxy;
        const me = this;

        this.setState({
            isBusy: true,
            faulted: false,
            isLoaded: false
        });

        return Promise.all([

            //  fetch dashboard statistics
            proxy.processRequest(MiscEndpoints.getAdminDashboardStats()).then((response) =>{

                me.setStateSafe({
                    dashboardStats: response.getPayload(),
                    dashboardStatsLoaded: true
                });

            }),

            //  get request statistics
            me.fetchRequestsStats(),

            //  get analytics data
            me.fetchModelStats(),


        ]).then((values) =>{

            //  set loaded successfully
            me.setStateSafe({
                isLoaded: true,
                faulted: false,
                isBusy: false
            });

        }).catch((err) =>{
            me.enterErrorState(err);
        });

    }

    componentDidMount(){

        if(!this.state.isLoaded || !this.state.faulted) {
            return this.queryData();
        }

    }

    componentWillMount(){
        this._isMounted = true;
    }

    enterErrorState(err){

        this.setStateSafe({ faulted: true , isBusy : false });
        HTML.toastWarning(Utils.getResponseError(err));
    }

    onRequestTimeFrameChanged(timeFrame){

        //  persist session
        this.persistSession();

        //  query for stats
        this.fetchRequestsStats(timeFrame);

    }

    navigateUrl(url , args){
        this.props.history.push(url,args);
    }

    updateAnalyticsRange(range){

        this.setStateSafe({
            analyticsRangeOption: range
        }, () => {

            //  persist session
            this.persistSession();

            return this.fetchModelStats();
        });
    }

    getCreateStatsTimeLabelFormat(range){

        switch (range) {
            case AnalyticsRangeOptions.Monthly:
                return 'MMM YY';
            case AnalyticsRangeOptions.Weekly:
                return 'Wo [week]';
            case AnalyticsRangeOptions.Yearly:
                return 'YYYY';
        }

    }

    render() {

        const state = this.state;
        const stats = state.dashboardStats;
        const isBusy = state.isBusy;
        const { analyticsRangeOption  } = state;
        const labelFormat = this.getCreateStatsTimeLabelFormat(analyticsRangeOption);

        return (<DocumentTitle title={"Admin Dashboard"}>

                <div>

                <div className="container-fluid">
                    <div className="animated fadeIn">
                        <div className="row content-frame">
                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-info"
                                          icon="fa fa-tree"
                                          title="Hectarage"
                                          isLoading={isBusy}
                                          value={stats.tractorRequests.totalHectarage}
                                          tooltipTitle="Hectarage"
                                          tooltipContent="Shows accumulation of hectare(s) of all completed services."
                                          navigateText="Click to see"
                                          onClick={() =>  this.navigateUrl(`/requests?request_status=completed`) }/>

                            </div>

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-success"
                                          icon="fa fa-user"
                                          title="Tractor Operators"
                                          isLoading={isBusy}
                                          value={ stats.operators.total}
                                          tooltipTitle="Operators"
                                          tooltipContent="Indicates the total number of registered tractor operators."
                                          navigateText="Click to see"
                                          onClick={() =>  this.navigateUrl('/operators') }/>
                            </div>

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-warning"
                                          icon="fa fa-money"
                                          title="Total Income"
                                          isLoading={isBusy}
                                          value={stats.tractorRequests.totalIncome}
                                          preValue={AppVariables.CurrencyCode}
                                          tooltipTitle="Income"
                                          tooltipContent={`Displays the total revenue generated by completed requests. It is computed by summing the cost of all completed requests.`}
                                          navigateText="Click to see"
                                          onClick={() =>  this.navigateUrl(`/requests?request_status=completed`,{ filter: { completed: true } }) }/>
                            </div>


                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-primary"
                                          icon={<img src="/img/avatars/tractor_logo_white.png" width={42} height={42}/>}
                                          title="Registered Tractors"
                                          isLoading={isBusy}
                                          value={stats.tractors.total}
                                          tooltipTitle="Tractors"
                                          tooltipContent="Indicates the total number of registered tractors on the platform."
                                          navigateText="Click to see"
                                          onClick={() => this.navigateUrl('/tractors')}/>

                            </div>

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-primary"
                                          icon="icon-user"
                                          title="Tractor Owners"
                                          isLoading={isBusy}
                                          value={stats.owners.total}
                                          tooltipTitle="Owners"
                                          tooltipContent="Indicates the total number of registered tractor owners on the platform."
                                          navigateText="Click to see"
                                          onClick={() => this.navigateUrl('/tractor_owners')}/>

                            </div>

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-thick-green"
                                          icon="fa fa-users"
                                          title="FBO's"
                                          isLoading={isBusy}
                                          value={stats.fbo.total}
                                          tooltipTitle="FBO"
                                          tooltipContent="Indicates the total number of registered farmer based organizations (FBO) on the platform."
                                          navigateText="Click to see"
                                          onClick={() => this.navigateUrl('/fbo')}/>

                            </div>

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-dropbox"
                                          icon="fa fa-user-secret"
                                          title="Registered Farmers"
                                          isLoading={isBusy}
                                          value={stats.farmers.total}
                                          tooltipTitle="Farmers"
                                          tooltipContent="Indicates the total number of registered farmers on the platform."
                                          navigateText="Click to see"
                                          onClick={() => this.navigateUrl('/farmers')} />

                            </div>

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-danger"
                                          icon="fa fa-hourglass"
                                          title="Pending Requests"
                                          isLoading={isBusy}
                                          value={stats.tractorRequests.totalPaidUnassigned}
                                          tooltipTitle="Pending Requests"
                                          tooltipContent="Indicates the total number of paid but unassigned tractor requests."
                                          navigateText="Click to see"
                                          onClick={() => this.navigateUrl(`/requests?paid_only=true&request_status=unassigned`) }/>

                            </div>

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-success"
                                          icon="fa fa-toggle-on"
                                          title="Assigned Requests"
                                          isLoading={isBusy}
                                          value={stats.tractorRequests.assigned}
                                          tooltipTitle="Assigned Requests"
                                          tooltipContent="Indicates the total number of assigned tractor requests."
                                          navigateText="Click to see"
                                          onClick={() => this.navigateUrl(`/requests?request_status=assigned`) }/>

                            </div>

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-warning"
                                          icon="fa fa-money"
                                          title="Payouts"
                                          isLoading={isBusy}
                                          value={stats.tractorRequests.totalPayouts}
                                          preValue={AppVariables.CurrencyCode}
                                          tooltipTitle="Payouts"
                                          tooltipContent={`Displays the total amount of money (${AppVariables.CurrencyCode}) given to tractor owners from the total income revenue.`}/>

                            </div>

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-spotify"
                                          icon="fa fa-money"
                                          title="Commission"
                                          isLoading={isBusy}
                                          value={stats.tractorRequests.totalCommission}
                                          preValue={AppVariables.CurrencyCode}
                                          tooltipTitle="Commission"
                                          tooltipContent={`Displays the total amount of money (${AppVariables.CurrencyCode}) commissioned to ${AppVariables.AppCompanyName} from the total income revenue.`}
                                          navigateText="Click to see statistics"
                                          onClick={() => { /*this._commissionDlg.show()*/ } }/>

                                <CommissionInfoDialog ref={r => this._commissionDlg = r}/>

                            </div>

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-success"
                                          icon="icon-docs"
                                          title="Total No. Requests"
                                          isLoading={isBusy}
                                          value={stats.tractorRequests.total}
                                          tooltipTitle="Requests"
                                          tooltipContent="Displays the total number of tractor requests received on the platform."
                                          navigateText="Click to see"
                                          onClick={() => this.navigateUrl('/requests')}/>

                            </div>

                            <hr/>
                            {/*<div className="text-center">
                                <button className="btn btn-default">Show More...</button>
                            </div>*/}
                            <div className="card">
                                <div className="card-block">

                                    <StatisticsChart
                                        sessionKey="tractor_req_chart_state"
                                        keepState
                                        onTimeFrameChanged={(frame) => this.onRequestTimeFrameChanged(frame) }
                                        title="Tractor Requests (Statistics)"
                                        ref={(input)=> this._reqChart = input}
                                        sections={[
                                            {
                                                key: 'assigned_requests',
                                                borderWidth: 2,
                                                backgroundColor: Utils.convertHex(brandInfo,10),
                                                borderColor: brandInfo,
                                                label: 'Assigned Requests'
                                            },
                                            {
                                                key: 'completed_requests',
                                                label: 'Completed Requests',
                                                backgroundColor: 'transparent',
                                                borderColor: brandDanger,
                                                pointHoverBackgroundColor: '#fff',
                                                borderWidth: 1,
                                                borderDash: [8, 5],
                                            },
                                            {
                                                key: 'unassigned_requests',
                                                label: 'Unassigned Requests',
                                                backgroundColor: 'transparent',
                                                borderColor: brandSuccess,
                                                pointHoverBackgroundColor: '#fff',
                                                borderWidth: 2,
                                            },
                                            {
                                                key: 'cancelled_requests',
                                                label: 'Cancelled Requests',
                                                backgroundColor: 'transparent',
                                                borderColor: brandDanger,
                                                pointHoverBackgroundColor: '#fff',
                                                borderWidth: 1,
                                                borderDash: [8, 5],
                                            }
                                        ]}
                                        keepState={true}
                                        data={this.state.requestsStats} />

                                </div>
                                <div className="card-footer">
                                    <ul>

                                        <li>
                                            <div color="white">Tractors</div>
                                            <strong>{stats.tractors.total}</strong>
                                            <Progress className="progress-xs mt-2" color="success" value={ computePercentage(stats.tractors.total ,MaxExpectedTractors) } />
                                        </li>

                                        <li className="hidden-sm-down">
                                            <div color="white">FBO's</div>
                                            <strong>{stats.fbo.total} </strong>
                                            <Progress className="progress-xs mt-2" color="info" value={computePercentage(stats.fbo.total ,MaxExpectedFBO)} />
                                        </li>

                                        <li>
                                            <div color="white">Operators</div>
                                            <strong>{stats.operators.total}</strong>
                                            <Progress className="progress-xs mt-2" color="warning" value={computePercentage(stats.operators.total ,MaxExpectedOperators)} />
                                        </li>

                                        <li className="hidden-sm-down">
                                            <div color="white">Tractor Owners</div>
                                            <strong>{stats.owners.total}</strong>
                                            <Progress className="progress-xs mt-2" color="danger" value={computePercentage(stats.owners.total,MaxExpectedTractorOwners)} />
                                        </li>

                                        <li className="hidden-sm-down">
                                            <div color="white">Pending Request</div>
                                            <strong>{stats.tractorRequests.totalPaidUnassigned}</strong>
                                            <Progress className="progress-xs mt-2" color="primary" value={computePercentage(stats.tractorRequests.totalPaidUnassigned,MaxPendingRequests)} />
                                        </li>

                                    </ul>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

                <div style={{backgroundColor: 'white'}}>
                    <div className="container-fluid" >

                        {this.state.isLoaded ?
                            <div className="stats-bottom animated fadeIn" >

                                <div className="clearfix mb-2">

                                    <div className="pull-left">
                                        {this.state.isFetchingAnalyticsData && <MDSpinner size={24}/>}
                                    </div>


                                    <div className="pull-right">

                                        <UncontrolledButtonDropdown>
                                            <DropdownToggle caret>{formatAnalyticsRangeOption(this.state.analyticsRangeOption)}</DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem active={analyticsRangeOption === AnalyticsRangeOptions.Weekly} onClick={() => this.updateAnalyticsRange(AnalyticsRangeOptions.Weekly)}><Icon icon={ic_view_week}/> Weekly</DropdownItem>
                                                <DropdownItem active={analyticsRangeOption === AnalyticsRangeOptions.Monthly} onClick={() => this.updateAnalyticsRange(AnalyticsRangeOptions.Monthly)}><Icon icon={ic_view_day}/> Monthly</DropdownItem>
                                                <DropdownItem active={analyticsRangeOption === AnalyticsRangeOptions.Yearly} onClick={() => this.updateAnalyticsRange(AnalyticsRangeOptions.Yearly)}><Icon icon={ic_date_range}/> Yearly</DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledButtonDropdown>

                                    </div>

                                </div>

                                <hr/>

                                <div>
                                    <h3>Farmers</h3>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="row">

                                                <div className="col-md-4">
                                                    <b>Total Farmers:</b>
                                                    <p>{stats.farmers.total}</p>
                                                </div>

                                                <div className="col-md-4">
                                                    <b>With FBO's:</b>
                                                    <p>{Math.round((stats.farmers.fbo.assigned / stats.farmers.total) * 100) || 0}%</p>
                                                </div>

                                                <div className="col-md-4">
                                                    <b>Unassigned FBO's: </b>
                                                    <p>{Math.round((stats.farmers.fbo.unassigned / stats.farmers.total) * 100) || 0}%</p>
                                                </div>

                                            </div>

                                            <ul className="horizontal-bars type-2">
                                                <li>
                                                    <InfoBar title="Male" icon="icon-user" percent={Math.round( (stats.farmers.gender.male / stats.farmers.total) * 100)}/>
                                                </li>
                                                <li>
                                                    <InfoBar title="Female" icon="icon-user-female" percent={Math.round( (stats.farmers.gender.female / stats.farmers.total) * 100)}/>
                                                </li>
                                                <li>
                                                    <InfoBar title="Unassigned" icon="icon-user-unfollow" percent={Math.round((stats.farmers.gender.unassigned / stats.farmers.total) * 100)}/>
                                                </li>

                                            </ul>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-body">
                                                    <CreationLineChart title="Farmers (Created)" data={this.state.analyticState.farmerCreateStats} height={180} labelFormat={labelFormat}/>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <hr/>

                                <div>
                                    <h3>Tractor Operators</h3>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <ul className="horizontal-bars type-2">
                                                <li>
                                                    <InfoBar title="Male" icon="icon-user" percent={Math.round((stats.operators.gender.male / stats.operators.total) * 100)}/>
                                                </li>
                                                <li>
                                                    <InfoBar title="Female" icon="icon-user-female" percent={Math.round( (stats.operators.gender.female / stats.operators.total) * 100)}/>
                                                </li>
                                                <li>
                                                    <InfoBar title="Unassigned" icon="icon-user-unfollow" percent={Math.round((stats.operators.gender.unassigned / stats.operators.total) * 100)}/>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-body">
                                                    <CreationLineChart title="Tractor Operators (Created)" data={this.state.analyticState.operatorCreateStats} labelFormat={labelFormat}/>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <hr/>

                                <div>
                                    <h3>Tractor Owners</h3>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <ul className="horizontal-bars type-2">
                                                <li>
                                                    <InfoBar title="Individuals" icon="icon-user" percent={Math.round((stats.owners.individual/ stats.owners.total) * 100)}/>
                                                </li>
                                                <li>
                                                    <InfoBar title="Companies" icon="fa fa-users" percent={Math.round((stats.owners.company  / stats.owners.total) * 100)}/>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-body">
                                                    <CreationLineChart title="Tractor Owners (Created)" data={this.state.analyticState.ownerCreateStats} labelFormat={labelFormat}/>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <hr/>

                                <div>
                                    <h3>Tractors</h3>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <ul className="horizontal-bars">

                                                <li>
                                                    <div className="title">Active/Inactive</div>
                                                    <div className="bars" style={{left: '10%' , width: '90%' }}>
                                                        <Progress className="progress-xs" color="success" value={Math.round((stats.tractors.active/ stats.tractors.total) * 100)} />
                                                        <Progress className="progress-xs" color="danger" value={Math.round((stats.tractors.inactive / stats.tractors.total) * 100)} />
                                                    </div>
                                                </li>

                                                <li>
                                                    <div className="title">Assigned/Unassigned</div>
                                                    <div className="bars" style={{left: '10%' , width: '90%' }}>
                                                        <Progress className="progress-xs" color="success" value={Math.round((stats.tractors.assigned/ stats.tractors.total) * 100)} />
                                                        <Progress className="progress-xs" color="danger" value={Math.round((stats.tractors.unassigned/ stats.tractors.total) * 100)} />
                                                    </div>
                                                </li>

                                                <li className="legend">
                                                    <span className="badge badge-pill badge-success"></span> <small>Active/Assigned</small> &nbsp; <span className="badge badge-pill badge-danger"></span> <small>Inactive/Unassigned</small>
                                                </li>

                                            </ul>

                                        </div>

                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-body">
                                                    <CreationLineChart title="Tractors (Created)" data={this.state.analyticState.tractorCreateStats} labelFormat={labelFormat} />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <hr/>

                                <div>
                                    <div className="clearfix">
                                        <div className="pull-left">
                                            <h3>Farmer Based Organization (FBO's)</h3>
                                        </div>
                                        <div className="pull-right">
                                            <b>Total: </b> <Badge pill>{stats.fbo.total}</Badge>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <CreationLineChart title="FBO's (Created)" data={this.state.analyticState.fboCreateStats} labelFormat={labelFormat}/>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div> :
                                <div>
                                    <div style={{'padding' : 40 }} className="text-center">
                                        {this.state.faulted ? <div>
                                            <img src="/img/warning_icon.png"/>
                                                <p style={{color: '#000000'}}>Oops... Seems an error occurred</p>
                                                <Button disabled={this.state.isBusy} color="default" onClick={() => this.queryData()}><i className="fa fa-refresh"></i> Reload Page</Button>
                                            </div> :
                                            <div>
                                                <Spinkit name="ball-beat"></Spinkit>
                                                <p style={{color: '#b3b3b3'}}>Loading analytics data...</p>
                                            </div>}
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>
            </DocumentTitle>
        )
    }
}

export default DashboardAdmin;



// WEBPACK FOOTER //
// ./src/views/Dashboard/DashboardAdmin.js